import React, { FC, useCallback } from 'react';
import qs from 'query-string';

import * as Types from 'types';

export enum ShareProviders {
  facebook = 'facebook',
  twitter = 'twitter',
}

type Props = {
  provider: ShareProviders;
  url: Types.Artwork['url'];
};

type TitleProps =
  | { provider: ShareProviders.facebook; title?: never }
  | { provider: ShareProviders.twitter; title: Types.Artwork['title'] };

export const ShareSocialButton: FC<Props & TitleProps> = ({ provider, url, title }) => {
  const getUrl = (): string => {
    switch (provider) {
      case ShareProviders.twitter:
        return (
          'http://twitter.com/intent/tweet?' +
          qs.stringify({
            url: url,
            utm_campaign: 'Social Share',
            utm_medium: 'website',
            utm_source: provider,
            text: `View this artwork on Sedition ${title}`,
            via: 'seditionart',
          })
        );
      case ShareProviders.facebook:
        return (
          'https://www.facebook.com/sharer/sharer.php?' +
          qs.stringify({
            u: url,
            utm_campaign: 'Social Share',
            utm_medium: 'website',
            utm_source: provider,
          })
        );
    }
  };

  return (
    <a
      className='d-flex align-items-center'
      href={getUrl()}
      target='_blank'
      rel='noopener noreferrer'
    >
      <span className={`icon-${provider} mr-mini`} style={{ fontSize: '18px' }} />
      <span>{`Share on ${provider.charAt(0).toUpperCase() + provider.slice(1)}`}</span>
    </a>
  );
};
